// PropertyDetail.jsx (Kipinn Retail Version)
import { useEffect, useState } from "react";
import tw from "tailwind-styled-components";
import { toast } from "react-toastify";
import {
  BoxContainer,
  BoxHead,
  Underline,
} from "../../Components/Styles/PageStyles";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import Config, { landlord_property_type, listing_type } from "../../Config";
import { useSelector } from "react-redux";
import { useMutation } from "react-query";
import DeleteProperty from "../../Components/Properties/DeleteProperty";
import SideModal from "../../Components/SideModal";
import { FaBuilding } from "react-icons/fa";
import { capitalizeFirstLetter, statusConfig } from "../../helpers";
import PropertyBasicInfo from "../../Components/Properties/Details/PropertyBasicInfo";
import PropertyDocuments from "../../Components/Properties/Details/PropertyDocuments";
import { TenantDetailsLoading } from "../../Components/SkeletonLoading";
import LeaseDetails from "../../Components/Properties/Details/LeaseDetails";
import Menu from "../../Components/Properties/Details/Menu";
import moment from "moment";
import PropertySpecs from "../../Components/Properties/Details/PropertySpecs";
import PropertyFeatures from "../../Components/Properties/Details/PropertyFeatures";
import PropertyFinance from "../../Components/AddBrokerProperty/PropertyFinance";
import ImageUploadModal from "../../Components/Properties/Details/ImageUploadModal";
import InventoryImagesModal from "../../Components/Properties/Details/InventoryImages";
import EditLeaseDetails from "../../Components/Properties/Lease/EditLeaseDetails";
import AddLeaseDetail from "../../Components/Properties/Lease/AddLeaseDetails";

const PropertyDetail = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const inventoryId = location.state?.inventoryId;
  const locations = useSelector((state) => state.LocationsReducer.locations);
  const user = useSelector((state) => state.UserReducer.user);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [imageUpload, setImageUpload] = useState(false);
  const [activeTab, setActiveTab] = useState("overview");
  const [isDeleteProperty, setIsDeleteProperty] = useState(false);
  const [docs, setDocs] = useState([]);
  const [isDocumentAdd, setIsDocumentAdd] = useState(false);
  const [apiData, setApiData] = useState();
  const [propData, setPropData] = useState();
  const [images, setImages] = useState([]);
  const [showAddLeaseModal, setShowAddLeaseModel] = useState(false);
  const [showEditLeaseModel, setShowEditLeaseModel] = useState(false);

  const handleImageNavigation = (direction) => {
    if (direction === "next") {
      setCurrentImageIndex((prev) =>
        prev === images.length - 1 ? 0 : prev + 1,
      );
    } else {
      setCurrentImageIndex((prev) =>
        prev === 0 ? images.length - 1 : prev - 1,
      );
    }
  };

  // ================= FETCH PROPERTY =================inventory/detail?inventoryId=1111
  const fetchFunction = async () => {
    const response = await axios.get(
      `${Config.apiUrl}/inventory/detail?inventoryId=${inventoryId}`,
      {
        headers: {
          authorization: `Bearer ${user.token}`,
        },
      },
    );
    return response.data;
  };

  const getSuccess = (res) => {
    const propertyData = res?.data;

    setApiData(propertyData);
    // setDocs(propertyData?.docs || []);
    setDocs(propertyData?.documents || []);
    setPropData(propertyData);

    // extract images from API
    const apiImages = propertyData?.media?.flatMap((item) => item.images) || [];

    setImages(apiImages);
  };

  const {
    isLoading,
    mutate: getListMutate,
    error,
    data,
    isRefetching,
  } = useMutation(fetchFunction, {
    onSuccess: getSuccess,
  });

  useEffect(() => {
    getListMutate();
  }, [inventoryId]);

  // ================= DELETE PROPERTY =================
  const deletePropertyFunction = async (values) => {
    return await axios.post(`${Config.apiUrl}/inventory/delete`, values, {
      headers: {
        authorization: `Bearer ${user.token}`,
      },
    });
  };

  const { isLoading: deletePropertyLoading, mutate: deletePropertyMutate } =
    useMutation(deletePropertyFunction, {
      onSuccess: (data) => {
        setIsDeleteProperty(false);
        navigate("/inventory/operational");
        toast.success(data?.data?.msg || "Property deleted successfully");
      },

      onError: (error) => {
        setIsDeleteProperty(false);
        toast.error(
          error?.response?.data?.msg ||
            error?.message ||
            "Failed to delete property. Please try again.",
        );
      },
    });

  //---------Edit Overview------------
  const editBasicInfoFunction = async (values) => {
    return await axios.post(
      `${Config.apiUrl}/inventory/update/overview`,
      values,
      {
        headers: {
          "Content-Type": "application/json",
          authorization: `Bearer ${user.token}`,
        },
      },
    );
  };

  const editSuccess = (data) => {
    getListMutate();
    toast.success(data?.data?.msg || "Success");
  };

  const editError = (data) => {
    toast.error(data?.response?.data?.msg || "An Error Occured");
  };

  const {
    isLoading: editPropBasicInfoLoading,
    mutate: editPropBasicInfoMutate,
  } = useMutation(editBasicInfoFunction, {
    onSuccess: editSuccess,
    onError: editError,
  });

  //----Edit Inventory Specs---------
  const editInventorySpecsFunction = async (values) => {
    return await axios.post(
      `${Config.apiUrl}/inventory/update/specification`,
      values,
      {
        headers: {
          authorization: "Bearer " + user.token,
          "Content-Type": "application/json",
        },
      },
    );
  };

  const onEditSuccess = (data) => {
    getListMutate();
    toast.success(data?.data?.msg || "Success");
  };

  const onEditError = (data) => {
    toast.error(data?.response?.data?.msg || "An Error Occured");
  };

  const {
    isLoading: editInventorySpecsLoading,
    mutate: editInventorySpecsMutate,
  } = useMutation(editInventorySpecsFunction, {
    onSuccess: onEditSuccess,
    onError: onEditError,
  });

  //-----Edit Inventory Features-------
  const editInventoryFeaturesFunction = async (values) => {
    return await axios.post(
      `${Config.apiUrl}/inventory/update/features`,
      values,
      {
        headers: {
          authorization: "Bearer " + user.token,
          "Content-Type": "application/json",
        },
      },
    );
  };

  const onEditFeaturesSuccess = (data) => {
    getListMutate();
    toast.success(data?.data?.msg || "Success");
  };

  const onEditFeaturesError = (data) => {
    toast.error(data?.response?.data?.msg || "An Error Occured");
  };

  const {
    isLoading: editInventoryFeaturesLoading,
    mutate: editInventoryFeaturesMutate,
  } = useMutation(editInventoryFeaturesFunction, {
    onSuccess: onEditFeaturesSuccess,
    onError: onEditFeaturesError,
  });

  // -------- Upload Image --------
  const uploadImageFunction = async (formData) => {
    return await axios.post(`${Config.apiUrl}/inventory/media/add`, formData, {
      headers: {
        authorization: `Bearer ${user.token}`,
        "Content-Type": "multipart/form-data",
      },
    });
  };

  const onUploadImageSuccess = (data) => {
    setImageUpload(false);

    getListMutate(); // refresh property detail

    toast.success(data?.data?.msg || "Images Uploaded Successfully");
  };

  const onUploadImageError = (error) => {
    toast.error(error?.response?.data?.msg || "Upload Failed");
  };

  const { isLoading: isImageLoading, mutate: uploadImageMutate } = useMutation(
    uploadImageFunction,
    {
      onSuccess: onUploadImageSuccess,
      onError: onUploadImageError,
    },
  );

  //-----Edit Finance Detail-------
  const editInventoryFinanceFunction = async (values) => {
    return await axios.post(
      `${Config.apiUrl}/inventory/update/finance`,
      values,
      {
        headers: {
          authorization: "Bearer " + user.token,
          "Content-Type": "application/json",
        },
      },
    );
  };

  const onEditFinanceSuccess = (data) => {
    getListMutate();
    toast.success(data?.data?.msg || "Success");
  };

  const onEditFinanceError = (data) => {
    toast.error(data?.response?.data?.msg || "An Error Occured");
  };

  const {
    isLoading: editInventoryFinanceLoading,
    mutate: editInventoryFinanceMutate,
  } = useMutation(editInventoryFinanceFunction, {
    onSuccess: onEditFinanceSuccess,
    onError: onEditFinanceError,
  });

  // -------- Upload Document --------
  const uploadDocumentFunction = async (formData) => {
    return await axios.post(
      `${Config.apiUrl}/inventory/document/add`,
      formData,
      {
        headers: {
          authorization: `Bearer ${user.token}`,
          "Content-Type": "multipart/form-data",
        },
      },
    );
  };

  const onUploadDocumentSuccess = (data) => {
    setIsDocumentAdd(false);

    getListMutate();

    toast.success(data?.data?.msg || "Document Uploaded Successfully");
  };

  const onUploadDocumentError = (error) => {
    toast.error(error?.response?.data?.msg || "Upload Failed");
  };

  const { isLoading: isDocumentLoading, mutate: uploadDocumentMutate } =
    useMutation(uploadDocumentFunction, {
      onSuccess: onUploadDocumentSuccess,
      onError: onUploadDocumentError,
    });

  // -------- ADD LEASE --------
  const addLeaseFunction = async (values) => {
    return await axios.post(
      `${Config.apiUrl}/inventory/add/lease`,
      values,
      {
        headers: {
          authorization: `Bearer ${user.token}`,
          "Content-Type": "application/json",
        },
      },
    );
  };

  const { isLoading: addLeaseLoading, mutate: addLeaseMutate } = useMutation(
    addLeaseFunction,
    {
      onSuccess: (data) => {
        toast.success(data?.data?.msg || "Lease added successfully");
        setShowAddLeaseModel(false);
        getListMutate(); // refresh property data
      },
      onError: (error) => {
        toast.error(error?.response?.data?.msg || "Failed to add lease");
      },
    },
  );

  // -------- EDIT LEASE --------
const editLeaseFunction = async (values) => {
  return await axios.post(
    `${Config.apiUrl}/inventory/update/lease`,
    values,
    {
      headers: {
        authorization: `Bearer ${user.token}`,
        "Content-Type": "application/json",
      },
    }
  );
};

const { isLoading: editLeaseLoading, mutate: editLeaseMutate } =
  useMutation(editLeaseFunction, {
    onSuccess: (data) => {
      toast.success(data?.data?.msg || "Lease updated successfully");
      setShowEditLeaseModel(false);
      getListMutate(); // refresh
    },
    onError: (error) => {
      toast.error(error?.response?.data?.msg || "Failed to update lease");
    },
  });

  return (
    <BoxContainer>
      {isDeleteProperty && (
        <DeleteProperty
          setIsDeleteProperty={setIsDeleteProperty}
          isDeleteProperty={isDeleteProperty}
          deletePropertyLoading={deletePropertyLoading}
          deletePropertyMutate={deletePropertyMutate}
          inventoryId={apiData.id}
        />
      )}

      {!error && !isLoading && data && (
        <PageWrapper>
          {/* ================= HEADER CARD ================= */}
          <CardContainer>
            <HeaderWrapper>
              <ProfileWrapper>
                <AvatarWrapper>
                  <IconWrapper>
                    <FaBuilding className="text-primary-color" size={22} />
                  </IconWrapper>
                </AvatarWrapper>

                <TenantInfos>
                  <div className="flex items-center gap-2">
                    <TenantName>
                      {capitalizeFirstLetter(apiData?.inventoryName || "")}
                    </TenantName>
                    <span
                      className={`px-2 py-1 text-xs font-semibold rounded-full ${
                        statusConfig[apiData?.status]?.style ||
                        "bg-gray-100 text-gray-600"
                      }`}
                    >
                      {statusConfig[apiData?.status]?.label || "-"}
                    </span>
                  </div>
                  <TenantProp>{apiData?.address || ""}</TenantProp>
                </TenantInfos>
              </ProfileWrapper>
            </HeaderWrapper>

            {/* ===== Retail KPI Info Grid ===== */}
            <CardBody>
              <InfoGrid>
                <InfoItem>
                  <InfoLabel>Inventory Id</InfoLabel>
                  <InfoValue>#{apiData?.uniqueId || ""}</InfoValue>
                </InfoItem>

                <InfoItem>
                  <InfoLabel>Listing Type</InfoLabel>
                  <InfoValue className="capitalize">
                    {listing_type.find(
                      (item) => item.value === apiData?.listingType,
                    )?.label || "-"}
                  </InfoValue>
                </InfoItem>

                <InfoItem>
                  <InfoLabel>Inventory Type</InfoLabel>
                  <InfoValue>
                    {landlord_property_type.find(
                      (item) => item.value === apiData?.inventoryType,
                    )?.label || "-"}
                  </InfoValue>
                </InfoItem>

                <InfoItem>
                  <InfoLabel>Location</InfoLabel>
                  <InfoValue>
                    {locations?.length
                      ? locations.find((loc) => loc.id === apiData?.locationId)
                          ?.name || "-"
                      : "-"}
                  </InfoValue>
                </InfoItem>
              </InfoGrid>
            </CardBody>
          </CardContainer>

          {/*
          HEROSECTION
          */}

          <SideModal isOpen={imageUpload} onClose={() => setImageUpload(false)}>
            <ImageUploadModal
              handleClose={() => setImageUpload(false)}
              setImageUpload={setImageUpload}
              bhk={apiData.inventorySubType}
              uploadImageMutate={uploadImageMutate}
              isImageLoading={isImageLoading}
              inventoryType={apiData.inventoryType}
              inventoryId={apiData.id}
            />
          </SideModal>

          {/* ================= MAIN CONTENT ================= */}
          <MainContent>
            <div className="mx-auto flex justify-between">
              <TabContainer>
                <Tab
                  active={activeTab === "overview"}
                  onClick={() => setActiveTab("overview")}
                >
                  Overview
                </Tab>

                <Tab
                  active={activeTab === "finance"}
                  onClick={() => setActiveTab("finance")}
                >
                  Finance
                </Tab>

                {apiData?.belongsToType === 3 && (
                  <Tab
                    active={activeTab === "landlord"}
                    onClick={() => setActiveTab("landlord")}
                  >
                    Owner Details
                  </Tab>
                )}

                {apiData?.belongsToType === 4 && (
                  <Tab
                    active={activeTab === "landlord"}
                    onClick={() => setActiveTab("landlord")}
                  >
                    Broker Details
                  </Tab>
                )}

                <Tab
                  active={activeTab === "documents"}
                  onClick={() => setActiveTab("documents")}
                >
                  Documents
                </Tab>

                <Tab
                  active={activeTab === "images"}
                  onClick={() => setActiveTab("images")}
                >
                  Media
                </Tab>
              </TabContainer>

              <Menu setIsDeleteProperty={setIsDeleteProperty} />
            </div>

            {/* ================= TAB CONTENT ================= */}
            <TabContent>
              {activeTab === "overview" && (
                <OverviewTab
                  editPropBasicInfoLoading={editPropBasicInfoLoading}
                  editPropBasicInfoMutate={editPropBasicInfoMutate}
                  apiData={apiData}
                  editInventorySpecsLoading={editInventorySpecsLoading}
                  editInventorySpecsMutate={editInventorySpecsMutate}
                  editInventoryFeaturesLoading={editInventoryFeaturesLoading}
                  editInventoryFeaturesMutate={editInventoryFeaturesMutate}
                />
              )}

              {activeTab === "finance" && (
                <PropertyFinance
                  apiData={apiData}
                  editInventoryFinanceLoading={editInventoryFinanceLoading}
                  editInventoryFinanceMutate={editInventoryFinanceMutate}
                />
              )}

              {activeTab === "documents" && (
                <PropertyDocuments
                  // apiData={apiData}
                  docs={docs}
                  setIsDocumentAdd={setIsDocumentAdd}
                  isDocumentAdd={isDocumentAdd}
                  uploadDocMutate={uploadDocumentMutate}
                  isDocLoading={isDocumentLoading}
                  inventoryId={apiData.id}
                />
              )}

              <SideModal
                isOpen={showAddLeaseModal}
                onClose={() => setShowAddLeaseModel(false)}
              >
                <AddLeaseDetail
                  handleClose={setShowAddLeaseModel}
                  selectedData={apiData}
                  addLandlordMutate={addLeaseMutate}
                  addLandlordLoading={addLeaseLoading}
                  inventoryId={inventoryId}
                />
              </SideModal>

              <SideModal
                isOpen={showEditLeaseModel}
                onClose={() => setShowEditLeaseModel(false)}
              >
                <EditLeaseDetails
                  handleClose={() => setShowEditLeaseModel(false)}
                  leaseData={apiData?.lease}

                  editLandlordMutate={editLeaseMutate}
                  editLandlordLoading={editLeaseLoading}
                />
              </SideModal>

              {activeTab === "landlord" && (
                <LeaseDetails
                  apiData={apiData}
                  landlordData={propData?.landlordData}
                  leaseDetails={propData?.leaseDetails}
                  setShowAddLeaseModel={setShowAddLeaseModel}
                  setShowEditLeaseModel={setShowEditLeaseModel}
                />
              )}

              {activeTab === "images" && (
                <InventoryImagesModal
                  images={images}
                  currentImageIndex={currentImageIndex}
                  setCurrentImageIndex={setCurrentImageIndex}
                  handleImageNavigation={handleImageNavigation}
                  setImageUpload={setImageUpload}
                />
              )}
            </TabContent>
          </MainContent>
        </PageWrapper>
      )}

      {(isLoading || isRefetching) && <TenantDetailsLoading />}
    </BoxContainer>
  );
};

// ================= OVERVIEW TAB =================
const OverviewTab = ({
  editPropBasicInfoLoading,
  editInventorySpecsLoading,
  editInventoryFeaturesLoading,
  editInventorySpecsMutate,
  editPropBasicInfoMutate,
  editInventoryFeaturesMutate,
  apiData,
}) => {
  return (
    <Wrapper>
      <BoxHead>
        <TabTitle>
          Basic Overview
          <Underline />
        </TabTitle>

        <div className="text-xs text-gray-500">
          Created on{" "}
          <span className="font-medium text-gray-700">
            {moment(apiData?.createdAt).format("DD, MMM YYYY")}
          </span>
        </div>
      </BoxHead>

      <PropertyBasicInfo
        editPropBasicInfoLoading={editPropBasicInfoLoading}
        editPropBasicInfoMutate={editPropBasicInfoMutate}
        apiData={apiData}
      />

      <BoxHead>
        <TabSubTitle>Inventory Specs</TabSubTitle>
      </BoxHead>

      <PropertySpecs
        apiData={apiData}
        editInventorySpecsLoading={editInventorySpecsLoading}
        editInventorySpecsMutate={editInventorySpecsMutate}
      />

      <BoxHead>
        <TabSubTitle>Custom Features</TabSubTitle>
      </BoxHead>

      <PropertyFeatures
        apiData={apiData}
        editInventoryFeaturesLoading={editInventoryFeaturesLoading}
        editInventoryFeaturesMutate={editInventoryFeaturesMutate}
      />
    </Wrapper>
  );
};

/* ================= STYLES ================= */

const MainContent = tw.div`p-3 rounded-lg bg-white shadow-sm mt-6`;
const TabContainer = tw.div`flex overflow-x-auto gap-6 px-4`;
const Tab = tw.button`relative px-1 py-3 text-sm whitespace-nowrap 
 ${({ active }) =>
   active
     ? "text-zinc-900 font-semibold border-b-2 border-zinc-900"
     : "text-zinc-500 hover:text-zinc-700"}`;
const TabContent = tw.div`py-6`;
const CardContainer = tw.div`bg-white rounded-xl shadow-sm border border-gray-200/60 overflow-hidden`;
const HeaderWrapper = tw.div`flex items-center gap-6 p-5 border-b border-gray-100`;
const ProfileWrapper = tw.div`flex items-center gap-4`;
const TenantInfos = tw.div`flex-1`;
const TenantName = tw.h2`text-md font-semibold text-gray-900`;
const TenantProp = tw.p`text-sm text-gray-500`;
const CardBody = tw.div`p-5`;
const InfoGrid = tw.div`flex flex-cols-1 md:flex-cols-2 lg:flex-cols-4 items-center justify-between`;
const InfoItem = tw.div``;
const InfoLabel = tw.div`text-gray-500 text-sm`;
const InfoValue = tw.p`text-base font-semibold text-gray-900`;
const Wrapper = tw.div`px-4 space-y-4 mt-2`;
const TabTitle = tw.h2`text-lg text-black font-semibold`;
const TabSubTitle = tw.h3`text-md font-semibold pb-2 text-black`;
const PageWrapper = tw.div`px-1`;
const AvatarWrapper = tw.div`flex items-center justify-center w-12 h-12`;
const IconWrapper = tw.div`w-12 h-12 rounded-xl bg-blue-50 flex items-center justify-center`;

export default PropertyDetail;
